export class ApiUtils {
  static isAPI2Url(url: string, configUrl: string): boolean {
    if (!url || !configUrl) {
      return false;
    }

    return url.includes(configUrl);
  }
}
